import { Generator } from 'shared/utils/models';

const TYPE = 'subAccounts';
export default new Generator(TYPE).createSystemListModel();
